export default "__VITE_ASSET__3ad92637__"